<script>
  import FeIcon from '../components/fe-icon.svelte';
  import { defaults, pages } from '../../config';
  import { formatMoney, formatNumber, goto } from '../../util';

  // optional sid
  export let sid;
  export let forms = [];
  export let siteCount = 0;
  export let returnTo;

  $: data = forms?.map(({ _id, name, formLinkCode, description, sid }) => ({
    _id,
    name,
    formLinkCode,
    description,
    sid,
  }));

  $: dataExists = data?.length;

  function triggerDeleteForm(fid) {
    return () => {
      if (!fid) {
        console.warn('fid required for form deletion');
      } else {
        goto(pages.forms.delete.url, fid, '?from=sites.overview');
      }
    };
  }
  function addForm() {
    if (sid) {
      goto(pages.forms.add.url, sid, returnTo);
    } else {
      goto(pages.forms.add.url, returnTo);
    }
  }
</script>

{#if siteCount && dataExists}
  <table>
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Form Link Code</th>
        <th scope="col">Name</th>
        <th scope="col">Submissions</th>
        <th scope="col" on:keydown={null} on:click={addForm}> Form Actions </th>
      </tr>
    </thead>

    <tbody>
      {#each forms || [] as row, idx}
        <tr>
          <th scope="row">{idx + 1}</th>
          <td>
            <a target="_blank" href="{defaults.formUrl}{row.formLinkCode}">
              {row.formLinkCode}
            </a>
          </td>
          <td>{row.name}</td>
          <td class="text-center">
            {formatNumber(row.submissions || 0)}
            <br />
            {formatMoney((row.submissions || 0) * 0.0005)}
          </td>
          <td class="cta">
            <div class="ctrl">
              <FeIcon name="x-circle" on:click={triggerDeleteForm(row._id)} />
              <FeIcon
                name="edit"
                on:click={() => goto(pages.forms.edit.url, row._id)}
              />
              <FeIcon
                name="eye"
                on:click={() => goto(pages.forms.overview.url, row._id)}
              />
              <FeIcon
                name="code"
                on:click={() => goto(pages.components.url, row.sid, row._id)}
              />
            </div>
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
{:else if !siteCount}
  <slot name="no-sites" />
{:else if !dataExists}
  <slot name="empty" />
{/if}
